module.exports = __webpack_public_path__ + "static/user-test-2-c18738821f3e6b47790d3d87d23a76fa.jpg";